// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__7a3ZN","description":"PatientConsentPreview_description__3pd7A"};